// if (!customElements.get('media-gallery')) {
//   customElements.define('media-gallery', class MediaGallery extends HTMLElement {
//     constructor() {
//       super();
//       this.elements = {
//         liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//         viewer: this.querySelector('[id^="GalleryViewer"]'),
//         thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
//       }
//       this.mql = window.matchMedia('(min-width: 750px)');
//       this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
//       this.prependMedia = this.dataset.disablePrepend != 'true';
//       if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
//       this.filteringOption = this.dataset.filteringOption;
//       if (!this.elements.thumbnails) return;

//       this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
//       this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//         mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
//       });
//       if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
//     }

//     onSlideChanged(event) {
//       const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
//       this.setActiveThumbnail(thumbnail);
//     }

//     setActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
//       if (filtering && currentVariant) {
//         const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
//         allSlides.forEach(slide => {
//           if (slide.dataset.alt === currentVariant[this.filteringOption] || slide.dataset.alt === 'always_display') {
//             slide.classList.remove('hidden');
//           } else {
//             slide.classList.add('hidden');
//           }
//         })
//       }

//       const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
//       this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//         element.classList.remove('is-active');
//       });
//       activeMedia.classList.add('is-active');

//       if (prepend && this.prependMedia) {
//         activeMedia.parentElement.prepend(activeMedia);
//         if (this.elements.thumbnails) {
//           const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
//           activeThumbnail.parentElement.prepend(activeThumbnail);
//         }
//         if (this.elements.viewer.slider) this.elements.viewer.resetPages();
//       }

//       this.preventStickyHeader();
//       window.setTimeout(() => {
//         if (this.elements.thumbnails) {
//           activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
//         }
//         if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
//           activeMedia.scrollIntoView({behavior: 'smooth'});
//         }
//       });
//       this.playActiveMedia(activeMedia);

//       if (filtering && currentVariant) {
//         if (this.elements.viewer && this.elements.viewer.initPages) this.elements.viewer.initPages();
//         if (this.elements.viewer && this.elements.viewer.update) this.elements.viewer.update();
//       }

//       if (!this.elements.thumbnails) return;
//       const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
//       this.setActiveThumbnail(activeThumbnail);
//       this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//     }

//     setActiveThumbnail(thumbnail) {
//       if (!this.elements.thumbnails || !thumbnail) return;

//       this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
//       thumbnail.querySelector('button').setAttribute('aria-current', true);
//       if (this.elements.thumbnails.isSlideVisible(thumbnail, false, 10)) return;

//       this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
//     }

//     announceLiveRegion(activeItem, position) {
//       const image = activeItem.querySelector('.product__modal-opener--image img');
//       if (!image) return;
//       image.onload = () => {
//         this.elements.liveRegion.setAttribute('aria-hidden', false);
//         this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
//           '[index]',
//           position
//         );
//         setTimeout(() => {
//           this.elements.liveRegion.setAttribute('aria-hidden', true);
//         }, 2000);
//       };
//       image.src = image.src;
//     }

//     playActiveMedia(activeItem) {
//       window.pauseAllMedia();
//       const deferredMedia = activeItem.querySelector('.deferred-media');
//       if (deferredMedia) deferredMedia.loadContent(false);
//     }

//     preventStickyHeader() {
//       this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//       if (!this.stickyHeader) return;
//       this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//     }

//     removeListSemantic() {
//       if (!this.elements.viewer.slider) return;
//       this.elements.viewer.slider.setAttribute('role', 'presentation');
//       this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
//     }
//   });
// }
if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        this.productInfo = document.getElementById(
          `ProductInfo-${this.dataset.section}`
        );

        this.prependMedia = this.dataset.disablePrepend !== 'true';
        this.filteringOption = this.dataset.filteringOption;

        /*
         * ID ảnh lấy từ tag first-image-X.
         * Ví dụ first-image-7 sẽ truyền ID ảnh số 7 của chính sản phẩm.
         */
        this.initialMediaId = this.dataset.initialMediaId || '';

        /*
         * Khóa ảnh mở đầu trong thời gian theme đang khởi tạo.
         * Ngăn variant mặc định ghi đè lại thành ảnh áo.
         */
        this.lockInitialMedia = Boolean(this.initialMediaId);
        this.hasUserInteracted = false;
        this.initialMediaTimers = [];

        if (
          this.productInfo &&
          window.Shopify &&
          Shopify.postLinksRetry
        ) {
          this.productInfo.initShareLinks();
        }

        /*
         * Chỉ mở khóa khi khách thực sự thao tác.
         */
        this.registerUserInteractions();

        if (this.elements.viewer) {
          this.elements.viewer.addEventListener(
            'slideChanged',
            debounce(this.onSlideChanged.bind(this), 500)
          );
        }

        if (this.elements.thumbnails) {
          this.elements.thumbnails
            .querySelectorAll('[data-target]')
            .forEach((mediaToSwitch) => {
              const button = mediaToSwitch.querySelector('button');

              if (!button) return;

              button.addEventListener('click', () => {
                this.releaseInitialMediaLock();

                this.setActiveMedia(
                  mediaToSwitch.dataset.target,
                  false
                );
              });
            });
        }

        if (
          this.dataset.desktopLayout &&
          this.dataset.desktopLayout.includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }

        /*
         * Áp dụng ảnh từ tag ngay khi gallery khởi tạo.
         * Chạy lặp lại vài lần để tránh slider hoặc variant mặc định ghi đè.
         */
        if (this.initialMediaId) {
          this.initializeCustomInitialMedia();
        } else {
          this.revealGallery();
        }
      }

      registerUserInteractions() {
        const markInteraction = () => {
          this.releaseInitialMediaLock();
        };

        if (this.elements.viewer) {
          this.elements.viewer.addEventListener(
            'pointerdown',
            markInteraction,
            { passive: true }
          );

          this.elements.viewer.addEventListener(
            'keydown',
            markInteraction
          );
        }

        if (this.elements.thumbnails) {
          this.elements.thumbnails.addEventListener(
            'pointerdown',
            markInteraction,
            { passive: true }
          );

          this.elements.thumbnails.addEventListener(
            'keydown',
            markInteraction
          );
        }

        /*
         * Khi khách bấm Type, Size, Color hoặc variant,
         * gallery được mở khóa để hoạt động bình thường.
         */
        if (this.productInfo) {
          this.productInfo.addEventListener(
            'pointerdown',
            markInteraction,
            { passive: true }
          );

          this.productInfo.addEventListener(
            'keydown',
            markInteraction
          );
        }
      }

      initializeCustomInitialMedia() {
        /*
         * Áp dụng ngay lập tức trước.
         */
        this.applyCustomInitialMedia();

        /*
         * Chạy lại sau khi trình duyệt tính kích thước slider.
         */
        requestAnimationFrame(() => {
          this.applyCustomInitialMedia();

          requestAnimationFrame(() => {
            this.applyCustomInitialMedia();
          });
        });

        /*
         * Theme đôi khi khởi tạo variant và slider trễ,
         * nên áp dụng lại để ảnh áo không ghi đè ảnh người.
         */
        this.initialMediaTimers.push(
          window.setTimeout(() => {
            this.applyCustomInitialMedia();
          }, 120)
        );

        this.initialMediaTimers.push(
          window.setTimeout(() => {
            this.applyCustomInitialMedia();
          }, 350)
        );

        this.initialMediaTimers.push(
          window.setTimeout(() => {
            this.applyCustomInitialMedia();

            /*
             * Sau khi trang ổn định, bỏ khóa.
             */
            this.lockInitialMedia = false;
            this.revealGallery();
          }, 700)
        );
      }

      applyCustomInitialMedia() {
        if (
          !this.initialMediaId ||
          !this.elements.viewer
        ) {
          this.lockInitialMedia = false;
          this.revealGallery();
          return;
        }

        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${this.initialMediaId}"]`
          );

        /*
         * Tag nhập số lớn hơn tổng số ảnh thì giữ gallery bình thường.
         */
        if (!activeMedia) {
          this.lockInitialMedia = false;
          this.revealGallery();
          return;
        }

        /*
         * Gỡ trạng thái active khỏi tất cả ảnh.
         */
        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((media) => {
            media.classList.remove('is-active');
          });

        /*
         * Hiện và kích hoạt đúng ảnh từ tag.
         */
        activeMedia.classList.remove('hidden');
        activeMedia.classList.add('is-active');

        /*
         * Chuyển slider chính đến ảnh được chọn bằng chế độ auto.
         * Không dùng smooth nên khách không nhìn thấy quá trình trượt.
         */
        const mediaSlider = activeMedia.parentElement;

        if (mediaSlider) {
          if (typeof mediaSlider.scrollTo === 'function') {
            mediaSlider.scrollTo({
              left: activeMedia.offsetLeft,
              behavior: 'auto'
            });
          } else {
            mediaSlider.scrollLeft = activeMedia.offsetLeft;
          }
        }

        /*
         * Cập nhật hệ thống slider của theme.
         */
        if (
          typeof this.elements.viewer.initPages === 'function'
        ) {
          this.elements.viewer.initPages();
        }

        if (
          typeof this.elements.viewer.update === 'function'
        ) {
          this.elements.viewer.update();
        }

        /*
         * Đánh dấu thumbnail được chọn nhưng không kéo dãy thumbnail.
         */
        if (this.elements.thumbnails) {
          const activeThumbnail =
            this.elements.thumbnails.querySelector(
              `[data-target="${this.initialMediaId}"]`
            );

          if (activeThumbnail) {
            activeThumbnail.classList.remove('hidden');

            this.setActiveThumbnail(
              activeThumbnail,
              false
            );
          }
        }

        this.playActiveMedia(activeMedia);
        this.revealGallery();
      }

      releaseInitialMediaLock() {
        this.hasUserInteracted = true;
        this.lockInitialMedia = false;

        this.initialMediaTimers.forEach((timer) => {
          window.clearTimeout(timer);
        });

        this.initialMediaTimers = [];
        this.revealGallery();
      }

      revealGallery() {
        this.classList.remove(
          'custom-initial-media-pending'
        );

        this.classList.add(
          'custom-initial-media-ready'
        );
      }

      onSlideChanged(event) {
        if (
          !this.elements.thumbnails ||
          !event.detail ||
          !event.detail.currentElement
        ) {
          return;
        }

        const currentElement =
          event.detail.currentElement;

        const currentMediaId =
          currentElement.dataset.mediaId;

        /*
         * Trong lúc gallery khởi tạo, không cho slider mặc định
         * đổi khỏi ảnh đã set bằng tag.
         */
        if (
          this.lockInitialMedia &&
          !this.hasUserInteracted &&
          currentMediaId !== this.initialMediaId
        ) {
          this.applyCustomInitialMedia();
          return;
        }

        const thumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${currentMediaId}"]`
          );

        /*
         * Khi tải trang chỉ cập nhật viền selected.
         * Chỉ kéo thumbnail khi khách đã thao tác.
         */
        this.setActiveThumbnail(
          thumbnail,
          this.hasUserInteracted
        );
      }

      setActiveMedia(
        mediaId,
        prepend,
        filtering = false,
        currentVariant = null
      ) {
        if (!this.elements.viewer || !mediaId) return;

        /*
         * Ngăn theme tự đổi về ảnh variant mặc định
         * trong quá trình trang vừa tải.
         */
        if (
          this.lockInitialMedia &&
          !this.hasUserInteracted &&
          mediaId !== this.initialMediaId
        ) {
          this.applyCustomInitialMedia();
          return;
        }

        if (filtering && currentVariant) {
          const allSlides = this.querySelectorAll(
            '.product__media-item, ' +
            '.thumbnail-list__item, ' +
            '.slider-counter__link'
          );

          allSlides.forEach((slide) => {
            const selectedValue =
              currentVariant[this.filteringOption];

            if (
              slide.dataset.alt === selectedValue ||
              slide.dataset.alt === 'always_display'
            ) {
              slide.classList.remove('hidden');
            } else {
              slide.classList.add('hidden');
            }
          });
        }

        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"]`
          );

        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });

        activeMedia.classList.remove('hidden');
        activeMedia.classList.add('is-active');

        /*
         * Giữ nguyên chức năng prepend ảnh variant của theme.
         */
        if (prepend && this.prependMedia) {
          if (activeMedia.parentElement) {
            activeMedia.parentElement.prepend(
              activeMedia
            );
          }

          if (this.elements.thumbnails) {
            const activeThumbnail =
              this.elements.thumbnails.querySelector(
                `[data-target="${mediaId}"]`
              );

            if (
              activeThumbnail &&
              activeThumbnail.parentElement
            ) {
              activeThumbnail.parentElement.prepend(
                activeThumbnail
              );
            }
          }

          if (
            this.elements.viewer.slider &&
            typeof this.elements.viewer.resetPages ===
              'function'
          ) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          const mediaSlider = activeMedia.parentElement;

          if (mediaSlider) {
            if (typeof mediaSlider.scrollTo === 'function') {
              mediaSlider.scrollTo({
                left: activeMedia.offsetLeft,
                behavior: 'smooth'
              });
            } else {
              mediaSlider.scrollLeft =
                activeMedia.offsetLeft;
            }
          }

          if (
            !this.elements.thumbnails ||
            this.dataset.desktopLayout === 'stacked'
          ) {
            activeMedia.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest'
            });
          }
        }, 0);

        this.playActiveMedia(activeMedia);

        if (filtering && currentVariant) {
          if (
            typeof this.elements.viewer.initPages ===
              'function'
          ) {
            this.elements.viewer.initPages();
          }

          if (
            typeof this.elements.viewer.update ===
              'function'
          ) {
            this.elements.viewer.update();
          }
        }

        if (!this.elements.thumbnails) return;

        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        if (!activeThumbnail) return;

        this.setActiveThumbnail(
          activeThumbnail,
          true
        );

        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(
        thumbnail,
        allowScroll = true
      ) {
        if (
          !this.elements.thumbnails ||
          !thumbnail
        ) {
          return;
        }

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((button) => {
            button.removeAttribute('aria-current');
          });

        const activeButton =
          thumbnail.querySelector('button');

        if (activeButton) {
          activeButton.setAttribute(
            'aria-current',
            'true'
          );
        }

        /*
         * Khi tải trang không kéo dãy thumbnail.
         */
        if (!allowScroll) return;

        if (
          typeof this.elements.thumbnails
            .isSlideVisible !== 'function' ||
          !this.elements.thumbnails.slider
        ) {
          return;
        }

        if (
          this.elements.thumbnails.isSlideVisible(
            thumbnail,
            false,
            10
          )
        ) {
          return;
        }

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
          behavior: 'smooth'
        });
      }

      announceLiveRegion(
        activeItem,
        position
      ) {
        if (
          !this.elements.liveRegion ||
          !activeItem
        ) {
          return;
        }

        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            'false'
          );

          if (
            window.accessibilityStrings &&
            window.accessibilityStrings.imageAvailable
          ) {
            this.elements.liveRegion.innerHTML =
              window.accessibilityStrings.imageAvailable.replace(
                '[index]',
                position
              );
          }

          window.setTimeout(() => {
            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              'true'
            );
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        if (!activeItem) return;

        if (
          typeof window.pauseAllMedia === 'function'
        ) {
          window.pauseAllMedia();
        }

        const deferredMedia =
          activeItem.querySelector('.deferred-media');

        if (
          deferredMedia &&
          typeof deferredMedia.loadContent ===
            'function'
        ) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (
          !this.elements.viewer ||
          !this.elements.viewer.slider
        ) {
          return;
        }

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        if (this.elements.viewer.sliderItems) {
          this.elements.viewer.sliderItems.forEach(
            (slide) => {
              slide.setAttribute(
                'role',
                'presentation'
              );
            }
          );
        }
      }
    }
  );
}